import styled from "styled-components";

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: ${(props) => props.alignitem};
  gap: 12px;
  justify-content: flex-end;
  position: relative;
  width: ${(props) => props.customwidth || "100%"};
  cursor: pointer;
`;

export const IconButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: var(--Color-Neutrals-Neutral-025, #F3F4F7);
  }
`;

export const PrimaryButton = styled.button`
  background-color: ${(props) => props.bg || "#0C53BB"};
  color: ${(props) => props.customcolor || "#FFFFFF"};
  font-size: 16px;
  font-weight: 500;
  padding: 8px 16px;
  border: ${(props) => props.customborder || "none"};
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "40px"};
  opacity: ${(props) =>
    props.disabled ? "0.4" : "1"}; /* Reduce opacity when disabled */

  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? props.bg || "#0C53BB"
        : props.bghover || "#0A47A3"}; /* No hover effect if disabled */
  }
`;

export const SeconadaryButton = styled.button`
  background-color: #ffffff;
  color: #121316;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #dddee3;
  border-radius: 8px;
  width: ${(props) => props.width || "auto"};
  height: ${(props) => props.height || "40px"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) =>
    props.disabled ? "0.4" : "1"}; /* Reduce opacity when disabled */

  &:hover {
    background-color: #dddee3;
  }
`;
export const MenuWrapper = styled.div`
  position: ${(props) => props.position || "absolute"};
  ${(props) =>
    props.bottom !== undefined && props.bottom !== ""
      ? `bottom: ${props.bottom};`
      : props.top !== undefined && props.top !== ""
      ? `top: ${props.top};`
      : `top: 20px;`}
  right: ${(props) => props.right || "0px"};
  background: white;
  box-shadow: 0px 0px 4px 0px #00000014;
  border-radius: 8px;
  border: 1px solid #dddee3;
  z-index: 3000;
  width: ${(props) => props.width || "fit-content"};
  height: auto;
  padding: 0;

  .menu-item {
    display: flex;
    align-items: center;
    padding: 12px;
    cursor: pointer;
    background: white;
    width: 100%;
    text-align: left;
    border-radius: 8px;
    border: none;
    white-space: nowrap;
    font-size: 13px;
    font-family: 'Manrope', sans-serif;
    color: #48566b;
    font-weight: 500;
  }

  .menu-item img {
    margin-right: 8px;
  }

  .menu-item:hover {
    background: #e9e9ed;
    border-radius: 8px;
  }

  .disabled {
    opacity: 0.4;
  }

  .danger {
    color: #ae3333;
  }
  .menu-item.danger:hover {
    background: var(--Color-Red-Red_075, #f7dede);
    border-radius: 8px;
  }
`;

export const MenuItemWrapper = styled.div`
  position: relative;
  width: 100%;
  z-index: 100;
  padding: ${(props) => (props.type === "share" ? "8px 0" : "0")};
  border-top: ${(props) =>
    props.type === "share" ? "1px solid #e5e7eb" : "none"};
  border-bottom: ${(props) =>
    props.type === "share" ? "1px solid #e5e7eb" : "none"};
`;

export const SubmenuWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 105%;
  margin-left: 10px;
  padding: 8px;
  z-index: 10;
  background: white;
  box-shadow: 0px 0px 4px 0px #00000014; // for styling dividers
  border-radius: 8px;
  border: 1px solid #dddee3;
  z-index: 100;
  width: ${(props) => props.width || "fit-content"};
  height: auto;
`;

export const buttonStyles = {
  backgroundColor: "#0C53BB",
  color: "#fff",
  textTransform: "none",
  fontFamily: "'Manrope', sans-serif",
  fontSize: "13px",
  fontWeight: 500,
  lineHeight: 1,
  whiteSpace: "nowrap",
  padding: "0 12px",
  borderRadius: "6px",
  boxShadow: "none",
  display: "flex",
  alignItems: "center",
  gap: "0px",
  flexShrink: 0,
  minWidth: 0,
  width: "fit-content",
  height: "30px",
  border: "1px solid #0C53BB",
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
    marginRight: 0,
  },
  "&:hover": {
    backgroundColor: "#0a4296",
    borderColor: "#0a4296",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#e0e0e0",
    borderColor: "#e0e0e0",
    color: "#9e9e9e",
  },
};

/*
 * Low-emphasis twin of `buttonStyles`, for toolbars where this button sits
 * beside other actions and should not read as the primary one.
 */
export const secondaryButtonStyles = {
  ...buttonStyles,
  backgroundColor: "#FFFFFF",
  color: "#48566B",
  border: "1px solid #DDE2E9",
  "& .MuiButton-endIcon": {
    marginLeft: "4px",
    marginRight: 0,
  },
  "&:hover": {
    backgroundColor: "#F5F6F9",
    borderColor: "#98A6BA",
    color: "#1B2028",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: "#F3F4F7",
    borderColor: "#DDE2E9",
    color: "#98A6BA",
  },
};
